module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-01-dfc8c43ddfd926f9e40b690d6fb055a0.svg";